import { TextField } from "@mui/material";
import React from "react";

type Props = {
	search: string;
	setSearch: Function;
};

export const SearchFilter = ({ search, setSearch }: Props) => {
	return (
		<div style={{ marginTop: 8 }}>
			<TextField
				style={{
					minWidth: "100%",
				}}
				label="Search"
				variant="outlined"
				size="small"
				value={search}
				onChange={(e) => setSearch(e.target.value)}
				autoComplete="off"
			/>
		</div>
	);
};
